import { Permissions } from "@/type/api";
import {
  ACTION_KEYS,
  FULL_ACCESS_ROLES,
  GRAVEYARD_ROLES,
  MODULE_KEYS,
  PAGE_KEYS,
} from "./keys";
import type { AppModuleDefinition } from "./types";

const REPORT_ROLES = [
  Permissions.Coordinator,
  Permissions.HealthcareCoordinator,
  Permissions.Physician,
  Permissions.HealthcareAdministrator,
  ...FULL_ACCESS_ROLES,
];

const CONFIRM_ROLES = [
  Permissions.Physician,
  Permissions.HealthcareAdministrator,
  ...FULL_ACCESS_ROLES,
];

const ADMIN_REVIEW_ROLES = [
  Permissions.HealthcareAdministrator,
  ...FULL_ACCESS_ROLES,
];

const CERTIFICATE_ROLES = [
  Permissions.Coordinator,
  Permissions.HealthcareCoordinator,
  Permissions.HealthcareAdministrator,
  ...FULL_ACCESS_ROLES,
];

export const graveyardModules: AppModuleDefinition[] = [
  {
    key: MODULE_KEYS.GRAVEYARD,
    label: "Graveyard",
    labelKey: "alkokh.sidebar.graveyard",
    icon: "tabler-grave-2",
    fallbackRoles: GRAVEYARD_ROLES,
    nav: {
      order: 40,
      titleKey: "alkokh.sidebar.graveyard",
      icon: "tabler-grave-2",
    },
    pages: [
      {
        key: PAGE_KEYS.GRAVEYARD_GRAVES,
        label: "Graves",
        labelKey: "alkokh.sidebar.graves",
        doctype: "Pet Death Record",
        paths: ["/graveyard", "/graveyard/graves"],
        pathPrefixes: ["/graveyard/graves/"],
        fallbackRoles: GRAVEYARD_ROLES,
        nav: {
          titleKey: "alkokh.sidebar.graves",
          icon: "tabler-grave",
          order: 10,
          to: { path: "/graveyard" },
        },
      },
    ],
    actions: [
      { key: ACTION_KEYS.GRAVEYARD_REPORT, label: "Report pet death", labelKey: "Report pet death", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: REPORT_ROLES },
      { key: ACTION_KEYS.GRAVEYARD_CONFIRM, label: "Confirm pet death", labelKey: "Confirm pet death", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: CONFIRM_ROLES },
      { key: ACTION_KEYS.GRAVEYARD_MANAGER_REVIEW, label: "Manager review pet death", labelKey: "Manager review pet death", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: ADMIN_REVIEW_ROLES },
      { key: ACTION_KEYS.GRAVEYARD_FINALIZE, label: "Finalize pet death", labelKey: "Finalize pet death", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: ADMIN_REVIEW_ROLES },
      { key: ACTION_KEYS.GRAVEYARD_ISSUE_CERTIFICATE, label: "Issue death certificate", labelKey: "Issue death certificate", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: CERTIFICATE_ROLES },
      { key: ACTION_KEYS.GRAVEYARD_CANCEL, label: "Cancel death record", labelKey: "Cancel death record", pageKey: PAGE_KEYS.GRAVEYARD_GRAVES, fallbackRoles: ADMIN_REVIEW_ROLES },
    ],
    search: [
      {
        group: "Clinical",
        icon: "tabler-grave-2",
        title: "Graveyard",
        url: { path: "/graveyard" },
        accessKey: PAGE_KEYS.GRAVEYARD_GRAVES,
        order: 45,
      },
    ],
  },
];
